import { SharedListService } from './../../../../shared-module/shared-services/shared-list.service';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBar,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UrlContant } from 'src/app/constants/router.contant';
import { COMMON_REGEXP } from 'src/app/constants/validations';
import { AuthenticationService } from 'src/app/public-module/services/authentication.service';
import { SharedService } from 'src/app/public-module/services/shared.service';
import { ValidationsComponent } from 'src/app/shared-module/component/validations/validations.component';
import { debounceTime, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-florist-sign-up',
  templateUrl: './florist-sign-up.component.html',
  styleUrls: ['./florist-sign-up.component.scss'],
})
export class FloristSignUpComponent
  extends ValidationsComponent
  implements OnInit {
  // Form Variables
  signupForm: FormGroup;

  // Data variablex
  isShowTempleNameField: boolean[] = [];
  templeList: any[] = [];
  countryList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  zipcodeList: any[] = [];
  selectedTempleName;
  isValidPassword: boolean;
  zipList: any;

  constructor(
    private _fb: FormBuilder,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _sharedService: SharedService,
    private sharedListService: SharedListService
  ) {
    super();
  }

  ngOnInit(): void {
    this.createFloristForm();
    this.getCountryList();
    this.onChangeZipName();
  }

  getCountryList() {
    this.sharedListService.countryListApi().subscribe((res) => {
      this.countryList = [res];
      this.signupForm.patchValue({
        country: this.countryList[0].id
      })
      this.getStateList(this.countryList[0]);
    });
  }

  getStateList(event) {
    const shortName = event && event.short_name;
    if (shortName) {
      this.sharedListService.stateListApi(shortName).subscribe((res) => {
        this.stateList = res;
      });
    }
  }

  getCityList(event) {
    const state = event && event.state;
    if (state) {
      this.sharedListService.cityListApi(event.state).subscribe((res) => {
        this.cityList = res;
      });
    }
  }

  getZipList(event){
    const city = event && event.city;
    if (city) {
      this.sharedListService.zipListApi(event.city).subscribe((res) => {
        this.zipList = res;
      });
    }
  }

  createFloristForm() {
    this.signupForm = this._fb.group(
      {
        fullname: [''],
        email: ['', [Validators.pattern(COMMON_REGEXP.EMAIL_ADDRESS_REGEXP)]],
        mobileNo: [
          '',
          [
            Validators.pattern(COMMON_REGEXP.MOBILE_REGEXP),
            Validators.minLength(9),
            Validators.maxLength(12),
          ],
        ],
        country: [''],
        state: [[]],
        city: [[]],
        zip: [[]],
        address: [''],
        password: ['', [Validators.minLength(6), Validators.maxLength(20)]],
        confirmPassword: ['', [Validators.required]],
      },
      { validator: this.passwordConfirming }
    );
  }

  passwordConfirming(control: AbstractControl) {
    const password: string = control.get('password').value;
    const confirmPassword: string = control.get('confirmPassword').value;
    if (password !== confirmPassword) {
      control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
    }
  }

  onFloristSignupSubmit(form: FormGroup) {
    if (form.valid) {
      const params = form.value;
      const formData: any = new FormData();
      formData.append('fullname', params['fullname']);
      formData.append('mobileNo', params['mobileNo']);
      formData.append('email', params['email']);
      formData.append('password', params['password']);
      formData.append('zip', params['zip']);
      formData.append('street_address', params['address']);

      this._authenticationService
        .floristRegisterPostApi(formData)
        .subscribe((res) => {
          if (
            res &&
            res.message === 'Thanks for the sign up, please confirm your mail'
          ) {
            this.signupForm.reset();
            this.isShowTempleNameField[0] = false;
            this._sharedService.onShowMessageBar(res.message);
            this._router.navigate(['/' + UrlContant.FLORIST_LOGIN]);
          } else {
            this._sharedService.onShowMessageBar(res.message);
          }
        });
    }
  }

  onChangeZipName() {
    this.signupForm
      .get('zip')
      .valueChanges.pipe(
        debounceTime(300),
        switchMap((values) => {
          let value = values;
          return this.formControls['zip'].value
            ? this._authenticationService.zipcodeListApi(value)
            : this.zipcodeList;
        })
      )
      .subscribe((res) => {
        this.zipcodeList = res.results;
      });
  }

  onBlur() {
    const zipcode_value = this.formControls['zip'].value;
    if (this.zipcodeList && this.zipcodeList.length > 0) {
      this.zipcodeList.filter((item) => {
        this.formControls['zip'].setValue(zipcode_value);
      });
    } else {
      this.formControls['zip'].setValue('');
    }
  }

  get loginUrl() {
    return '/' + UrlContant.FLORIST_LOGIN;
  }

  get formControls() {
    return this.signupForm.controls;
  }
}
